import React              from 'react';
import { useTranslation } from 'react-i18next';

import { useSiteSettings } from '../../../providers/siteSettings';

import CategoryGrid from './category-grid';

export const Category = function() {
  const { t } = useTranslation();

  const {
          data: {
                  FRONT_PAGE_SEO: {
                                    collections_entrance,
                                    collections_interior,
                                  },
                },
        } = useSiteSettings();

  return (
    <>
      {(collections_entrance || collections_interior) && (
        <div className={'category_container'}>
          <p className={'category_title'}>{t('label_popular_category')}</p>
          {collections_entrance && (
            <CategoryGrid
              className={'entrance_doors_container'}
              data={collections_entrance}
              title={t('entrance_doors')}
            />)}
          {collections_interior && (
            <CategoryGrid
              className={'interior_doors_container'}
              data={collections_interior}
              title={t('interior_doors')}
            />)}
        </div>
      )}
    </>
  );
};
